import {
  colors,
  cornerRadius,
  spacing,
  styled,
} from "../../../../stitches.config";
import { BaseButton } from "./BaseButton";

export const StyledActionButton = styled(BaseButton, {
  borderRadius: cornerRadius.radiusSm,
  padding: spacing["2xs"],
  // this is an icon-only button, which means we need to space based on the icon
  // itself and not the hypothetical text
  lineHeight: 0,
  "&[data-hovered]": {
    backgroundColor: colors.grey100,
  },
});
